import { BaseDto } from './base.dto';
import { RecipeDto } from './recipe.dto';
import { StockLevelDto } from './stockLevel.dto';
import { StockLocationDto } from './stockLocation.dto';

export class RecipeLevelDetailDto extends BaseDto {
    stockLevel?: StockLevelDto;
    stockLevelId: number;
    recipe?: RecipeDto;
    recipeId: number;
    recipeLocation?: StockLocationDto;
    recipeLocationId: number;
    quantity: number;
    outOfStock: boolean;
    batchQty: number;
    portionQty: number;
    splitQty: number;
    totalValue: number;
    totalAMT: number;
}
